import React from 'react';
import { AppState } from '@Redux/store';
import { connect } from 'react-redux';
import Repeater from '@Utils/Repeater';
import { MulticolorBar } from '@Builder/myArsenal/army/utils/multi-color.progess-bar.styled';
import { ProgressBarEntryView } from '@Selectors/arsenal/make/view/progress-bar-entry.view';

interface IMultiColorProgressBarProps {
  readings: ProgressBarEntryView[];
  showValues?: boolean;
  showScale?: boolean;
  showBars?: boolean;
  showLegends?: boolean;
}

const MultiColorProgressBar: React.FC<Props> = ({ readings, show  }) => {
  return (
    <MulticolorBar>
      {show.values && (<div className="values">
        <Repeater data={readings} indexPrefix="values">
          {(item: ProgressBarEntryView) => (
            <div className="value" style={{ 'color': item.color, 'width': item.pourcentage + '%' }}>
              <span>{Math.round(item.pourcentage)}%</span>
            </div>
          )}
        </Repeater>
      </div>)}
      {show.scale && (<div className="scale">
        <Repeater data={readings} indexPrefix="values">
          {(item: ProgressBarEntryView) => (
            <div className="graduation" style={{ 'color': item.color, 'width': item.pourcentage + '%' }}>
              <span>|</span>
            </div>
          )}
        </Repeater>
      </div>)}
      {show.bars && (<div className="bars">
        <Repeater data={readings} indexPrefix="values">
          {(item: ProgressBarEntryView) => (
            <div className="bar" style={{ 'backgroundColor': item.color, 'width': item.pourcentage + '%' }}>

            </div>
          )}
        </Repeater>
      </div>)}
      {show.legends && (<div className="legends">
        <Repeater data={readings} indexPrefix="values">
          {(item: ProgressBarEntryView) => (
            <div className="legend">
              <span className="dot" style={{ 'color': item.color }}>●</span>
              <span className="label">{item.name}</span>
            </div>
          )}
        </Repeater>
      </div>)}
    </MulticolorBar>
  );
};

const mapStateToProps = (_: AppState, ownProps: IMultiColorProgressBarProps) => ({
  readings: ownProps.readings.filter(item => item.pourcentage > 0),
  show: {
    values: ownProps.showValues ?? true,
    scale: ownProps.showScale ?? false,
    bars: ownProps.showBars ?? true,
    legends: ownProps.showLegends ?? true
  },
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MultiColorProgressBar);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  IMultiColorProgressBarProps;
